import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

// Browser-tab titles and Google descriptions for every page.
// Add a line here whenever a new page is added to App.js.
const SITE = "Excellence Care";
const DEFAULT_DESCRIPTION =
  "Excellence Care Ltd provides home care, supported living and residential care in Essex and London. Call 01268 988500.";

export const PAGES = {
  "/": {
    title: "Excellence Care | Home Care, Supported Living & Residential Care",
    description: DEFAULT_DESCRIPTION,
  },
  "/aboutus": { title: "About Us", description: "Who we are and how Excellence Care supports people to live well." },
  "/excellencecarevision": { title: "Our Vision & Mission" },
  "/welcomingdiversity": { title: "Welcoming Diversity" },
  "/awards": { title: "Awards" },
  "/team": { title: "Our Team" },
  "/contact": {
    title: "Contact Us",
    description: "Contact Excellence Care: call 01268 988500, email info@excellence-care.co.uk or visit us at St Davids Court, London Road, Basildon, SS16 4PY.",
  },
  "/career": {
    title: "Careers & Jobs",
    description: "Care jobs with Excellence Care in Basildon, Pitsea, Wickford and Canvey Island. Full paid training, no experience needed.",
  },
  "/careservice": { title: "Our Care Services" },
  "/domiciliarycare": {
    title: "Domiciliary Care (Home Care)",
    description: "Home care from Excellence Care, helping people stay safe and independent in their own homes.",
  },
  "/residentialcare": { title: "Residential Care" },
  "/autism": { title: "Autism Support" },
  "/learningdisability": { title: "Learning Disability Support" },
  "/pmld": { title: "Profound and Multiple Learning Disabilities (PMLD)" },
  "/mais": { title: "Meeting the Accessible Information Standard" },
  "/covid19updates": { title: "COVID-19 Updates" },
  "/healthandsafety": { title: "Health & Safety" },
  "/laws": { title: "Laws and Standards We Follow" },
  "/preventingfalls": {
    title: "Preventing Falls",
    description: "Practical advice to help older and disabled people reduce the risk of falls at home.",
  },
  "/blog": { title: "Blog" },
  "/gdpr": { title: "Privacy Policy (GDPR)" },
  "/waverleylodge": { title: "Waverley Lodge" },
  "/cranbrookmews": { title: "Cranbrook Mews" },
  "/easternlodge": { title: "Eastern Lodge" },
  "/graysdeck": { title: "Grays Deck" },
  "/wickford": { title: "Wickford" },
  "/clayburnlodge": { title: "Clayburn Lodge" },
  "/daviescourt": { title: "St David's Court" },
  "/benfleethouse": { title: "Benfleet House" },
  "/priors": { title: "Priors" },
  "/seaview": { title: "Sea View" },
  "/dewlands": { title: "Dewlands" },
  "/northcolne": { title: "North Colne" },
  "/appointment": { title: "Contact Us" },
};

const cleanPath = (path) => (path.length > 1 ? path.replace(/\/+$/, "") : path);

export const isKnownPage = (path) => Boolean(PAGES[cleanPath(path)]);

const setMeta = (name, content) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export const PageMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = PAGES[cleanPath(pathname)];
    if (!page) {
      document.title = `Page not found | ${SITE}`;
      setMeta("robots", "noindex");
      return;
    }
    document.title =
      cleanPath(pathname) === "/" ? page.title : `${page.title} | ${SITE}`;
    setMeta("description", page.description || DEFAULT_DESCRIPTION);
    setMeta("robots", "index, follow");
  }, [pathname]);
  return null;
};

export const NotFound = () => {
  const { pathname } = useLocation();
  if (isKnownPage(pathname)) return null;
  return (
    <div className="container py-5 text-center" style={{ marginTop: "140px", marginBottom: "60px" }}>
      <h1 className="display-5 mb-3">Sorry, we can't find that page</h1>
      <p className="mb-4">
        The page may have moved, or the address may have been typed incorrectly.
      </p>
      <Link to="/" className="btn btn-primary py-3 px-5 me-2 mb-2">
        Go to the home page
      </Link>
      <Link to="/contact" className="btn btn-dark py-3 px-5 mb-2">
        Contact us
      </Link>
      <p className="mt-4">
        Or call us on <a href="tel:+441268988500">01268 988500</a>.
      </p>
    </div>
  );
};
